import { render, staticRenderFns } from "./MktMantPanelPubli.vue?vue&type=template&id=ec78408a&"
import script from "./MktMantPanelPubli.vue?vue&type=script&lang=js&"
export * from "./MktMantPanelPubli.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports